import React from 'react'

import { Container } from '@/components/shared/UnrecoverableError/components/InstructionsList.styled'
import { UnrecoverableErrorEntry } from '@/components/shared/UnrecoverableError/types'
import { ENTRIES } from '@/constants/content-stack'
import { useContentStack } from '@/services/content-stack'

export function InstructionsList() {
  const { entry } = useContentStack<UnrecoverableErrorEntry>({
    entryParams: ENTRIES.UNRECOVERABLE_ERROR,
    ensuresEntryFulfilled: true,
  })

  return (
    <Container>
      {entry.instructions.map((__html) => (
        <div
          key={__html}
          dangerouslySetInnerHTML={{
            __html,
          }}
        ></div>
      ))}
    </Container>
  )
}
